import { generateObjectSlug } from '../../../../../utils/generateObjectSlug.js';

export const appActionSlug = {
  key: 'slug',
  type: 'app',
  label: 'Action Slug',
  description: 'The slug of the action.',
  path: 'actions[id:{{actionId}}].slug',
  shouldRun: ({ changes }) => {
    return changes?.some((change) => change?.path?.includes('name')) && !changes?.some((change) => change?.path?.includes('slug'));
  },
  handler: async ({ app, action, changes }) => {
    const change = changes?.find((change) => change?.path?.includes('name'));
    const formattedSlug = generateObjectSlug(change?.value || '');

    if (formattedSlug === action?.slug) {
      return { success: true, data: { needsSuggestion: false } };
    }

    return {
      success: true,
      data: { needsSuggestion: true, suggestedValue: formattedSlug }
    };
  }
};
